import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IDeltaHedgeExeManagementTableReport,
  IDeltaHedgeExeManagementTableSearchParam,
} from "../../../Interfaces/deltaHedgeExe";
import { CommonTableUI } from "../../TableTemplate/common";
import { getDeltaHedgeExeManagementTable } from "../../../Requests/deltaHedgeExe";
import { Additional } from "./Additional";

interface IProps {
  searchParams: IDeltaHedgeExeManagementTableSearchParam;
  refreshFlag: boolean;
  onFetchComplete: () => void;
}

const DeltaHedgeExeManagementTable = ({
  searchParams,
  refreshFlag,
  onFetchComplete,
}: IProps) => {
  return (
    <TableTemplate<
      IDeltaHedgeExeManagementTableSearchParam,
      IDeltaHedgeExeManagementTableReport
    >
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          refreshFlag={refreshFlag}
          AdditionalBody={Additional}
          tableBoxClassName="!max-h-[800px]"
          withSelect
        />
      )}
      getDataTable={getDeltaHedgeExeManagementTable}
      searchParameters={searchParams}
      onFetchComplete={onFetchComplete}
    />
  );
};

export default DeltaHedgeExeManagementTable;
